import React, { useEffect, useState } from 'react';
import './Revenue.css'
import INCSUBSearchbar from '../common/SearchBar/INCSUBSearchbar';
import INCSUBRevenueIncomeCard from './RevenueIncomeCard';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { deleteCustomTxn, getRevenueData } from '../../services/revenueServices';
import DatePicker from 'react-datepicker';
import INCSUBAddCustomTransaction from '../Customtransaction/AddCustomTransaction';
import { setRevenueData, setRevenuePath } from '../../features/revenue/revenueSlice';
import ReactPaginate from 'react-paginate';
import INCSUBButton from '../common/Button/INCSUBButton';
import INCSUBRequestList from './requestList/RequestList';
import INCSUBOrderDetails from './OrderDetails';


function INCSUBRevenue() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [pageNumber, setPageNo] = useState(0);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [searchKey, setSearchKey] = useState('')
    const revenueData = useSelector((state) => state.revenue.revenueData);
    const revenuePath = useSelector((state) => state.revenue.revenuePath)
    const [isAddtxn, setIsAddtxn] = useState(false);
    const [isAsk, setIsAsk] = useState(false);
    const [isOpenPopUp, setIsOpenPopup] = useState(false);
    const [txnDeleteLoader, setDeleteTxnLoader] = useState();
    const [selectedTxn, setSelectedTxn] = useState(null);
    const [isFocused, setIsFocused] = useState('Income')
    const [currentPage, setCurrentPage] = useState(0);
    const [shimmer, setShimmer] = useState(false);
    const [isOrderHistory, setIsOrderHistory] = useState();
    const [txnType, setTxnType] = useState('CREDIT')


    const fetchRevenue = async (searchKey = '', type = 'Income', pageNo = pageNumber) => {
        setShimmer(true);
        if (type === 'Income') {
            setTxnType('CREDIT');
        } else {
            setTxnType('DEBIT');
        }
        try {
            const revenueData = await getRevenueData(searchKey, startDate ? convertDateFormat(startDate) : " ", endDate ? convertDateFormat(endDate) : " ", pageNo, type);
            if (revenueData.status === 200) {
                dispatch(setRevenueData(revenueData.data.data))
            } else if (revenueData.status === 301) {
                toast.error("Network Error");
            } else if (revenueData.status === 500) {
                toast.error("Internal server error");
            } else if (revenueData.status === 401) {
                window.localStorage.setItem('userData', null);
                window.localStorage.setItem('token', null);
                navigate('/login');
            } else if (![200, 401].includes(revenueData.status)) {
                toast.error(revenueData.data.message)
            }
        } catch (error) {
            toast.error("Something went wrong")
        } finally {
            setShimmer(false)
        }
    }
    useEffect(() => {
        if (revenuePath === '/financialinsights') {
            fetchRevenue();
        }

    }, [startDate, endDate])


    const handleSearch = (searchKey) => {
        setSearchKey(searchKey)
        fetchRevenue(searchKey)
    }
    const svgIncomeSvg = (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.11111 24.8889H26.4444C27.3036 24.8889 28 25.5853 28 26.4444C28 27.3036 27.3036 28 26.4444 28H1.55556C0.696446 28 0 27.3036 0 26.4444V1.55556C0 0.696446 0.696446 0 1.55556 0C2.41467 0 3.11111 0.696446 3.11111 1.55556V24.8889Z" fill="#4AD991" />
            <path opacity="0.5" d="M8.91256 18.176C8.32498 18.8027 7.34057 18.8345 6.71382 18.2469C6.08707 17.6593 6.05531 16.6749 6.64289 16.0481L12.4762 9.82591C13.0445 9.21977 13.9888 9.1672 14.6208 9.70653L19.2248 13.6353L25.2235 6.03704C25.7558 5.36274 26.734 5.24766 27.4083 5.78C28.0826 6.31235 28.1977 7.29052 27.6653 7.96482L20.6653 16.8315C20.1186 17.524 19.1059 17.6237 18.4347 17.0509L13.7306 13.0367L8.91256 18.176Z" fill="#4AD991" />
        </svg>
    )

    const svgExpense = (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.11111 24.8889H26.4444C27.3036 24.8889 28 25.5853 28 26.4444C28 27.3036 27.3036 28 26.4444 28H1.55556C0.696446 28 0 27.3036 0 26.4444V1.55556C0 0.696446 0.696446 0 1.55556 0C2.41467 0 3.11111 0.696446 3.11111 1.55556V24.8889Z" fill="#F93C65" />
            <path opacity="0.5" d="M8.91256 5.93342C8.32498 5.30667 7.34057 5.27492 6.71382 5.8625C6.08707 6.45008 6.05531 7.43449 6.64289 8.06124L12.4762 14.2835C13.0445 14.8896 13.9888 14.9422 14.6208 14.4028L19.2248 10.4741L25.2235 18.0723C25.7558 18.7466 26.734 18.8617 27.4083 18.3294C28.0826 17.797 28.1977 16.8189 27.6653 16.1446L20.6653 7.27789C20.1186 6.58533 19.1059 6.48572 18.4347 7.05849L13.7306 11.0726L8.91256 5.93342Z" fill="#F93C65" />
        </svg>

    )

    const profitIcon = (
        <svg width="30" height="34" viewBox="0 0 30 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 11.3152L12.9005 18.7633C13.0394 18.8435 13.1851 18.9014 13.3333 18.9382V33.3834L0.920065 26.0372C0.349784 25.6997 0 25.0863 0 24.4236V11.3152ZM30 11.1172V24.4236C30 25.0863 29.6502 25.6997 29.0799 26.0372L16.6667 33.3834V18.8116C16.6969 18.7965 16.7269 18.7804 16.7566 18.7633L30 11.1172Z" fill="#FEC53D" />
            <path opacity="0.499209" fill-rule="evenodd" clip-rule="evenodd" d="M0.405273 7.70142C0.562849 7.50244 0.761736 7.33426 0.993616 7.21076L14.1186 0.2201C14.6696 -0.0733665 15.3305 -0.0733665 15.8815 0.2201L29.0065 7.21076C29.1852 7.30596 29.3444 7.42771 29.4801 7.56966L15.0899 15.8778C14.9953 15.9325 14.9081 15.995 14.8286 16.064C14.7491 15.995 14.6618 15.9325 14.5672 15.8778L0.405273 7.70142Z" fill="#FEC53D" />
        </svg>

    )

    const convertDateFormat = (date) => {
        if (date === '') {
            return ""
        }
        const dateObj = new Date(date);
        const formattedDate = dateObj.toLocaleDateString("en-GB", { year: "numeric", month: "2-digit", day: "2-digit" }).replace("/", "/");
        const splitDate = formattedDate.split('/')

        if (splitDate[2].length === 4) {
            return splitDate[2] + "-" + splitDate[1] + "-" + splitDate[0]
        }
        return formattedDate;
    }

    const formatDateTime = (dateTime) => {
        const date = new Date(dateTime);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = date.toLocaleDateString("en-GB", options).replace(",", "");
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const period = hours >= 12 ? "PM" : "AM";
        const formattedTime = `${formattedDate} ${hours % 12 || 12}:${minutes} ${period}`;
        return `${formattedTime}`;
    };


    const handleType = (type) => {
        if (type !== "Profit") {
            setCurrentPage(0);
            setPageNo(0)
            setIsFocused(type);
            fetchRevenue(searchKey, type, 0);
        }

    }


    const handleDelete = async (txnData) => {
        setDeleteTxnLoader(true)

        try {
            const postTxnData = await deleteCustomTxn(txnData.transactionInfoId);
            if (postTxnData.status === 200) {
                const updatedData = revenueData && revenueData.transactionDtoList.filter((txn) => txn.transactionInfoId !== txnData.transactionInfoId);
                if (txnData?.transactionType === 'CREDIT') {
                    const updatedIncome = parseFloat(revenueData.profitLossDto.totalIncome) - txnData.transactionAmount;
                    const totalExpense = parseFloat(revenueData.profitLossDto.totalExpense);

                    dispatch(setRevenueData({
                        ...revenueData,
                        profitLossDto: {
                            ...revenueData.profitLossDto,
                            totalIncome: updatedIncome + ".00",
                            totalProfit: (updatedIncome - totalExpense) + ".00"
                        },
                        transactionDtoList: [...updatedData]
                    }));

                } else {
                    const updatedExpense = parseFloat(revenueData.profitLossDto.totalExpense) - txnData.transactionAmount;
                    const totalIncome = parseFloat(revenueData.profitLossDto.totalIncome);

                    dispatch(setRevenueData({
                        ...revenueData,
                        profitLossDto: {
                            ...revenueData.profitLossDto,
                            totalExpense: updatedExpense + ".00",
                            totalProfit: (totalIncome - updatedExpense) + ".00"
                        },
                        transactionDtoList: [...updatedData]
                    }));
                }

                setIsOpenPopup(false);
                setIsAsk(false);
            } else if (postTxnData.status === 301) {
                toast.error("Network Error");
            } else if (postTxnData.status === 500) {
                toast.error("Internal server error");
            } else if (postTxnData.status === 401) {
                window.localStorage.setItem('token', null);
                window.localStorage.setItem('userData', null);

                navigate('/login')
            } else if (![201, 401].includes(postTxnData.status)) {
                toast.error(postTxnData.data.message);
                setIsAsk(false)
                setDeleteTxnLoader(false)
            }

        } catch (err) {

            toast.error("Something went wrong")
        } finally {
            setDeleteTxnLoader(false)
        }
    }

    const handleRequestList = () => {
        dispatch(setRevenuePath('/txnRequestList'))
    }

    const [orderId, setOrderId] = useState(false);
    const handleOrderHistoryPopup = async (orderId) => {
        setOrderId(orderId)
        setIsOrderHistory(!isOrderHistory);
    }

    function PaginatedItems() {
        const [itemOffset, setItemOffset] = useState(0);
        const pageCount = revenueData ? revenueData.totalPages : 0;
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
            setPageNo(event.selected);
            fetchRevenue(searchKey, isFocused, event.selected)
            setCurrentPage(event.selected)
            setItemOffset(event.selected);
        };


        return (

            <div className='INCSUBComplaints_list_section_container'>{
                !shimmer && revenueData && revenueData.transactionDtoList && revenueData.transactionDtoList.length > 0 && pageCount > 1 ? <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={currentPage}
                /> : null
            }



            </div>


        );
    }


    return (
        <>{revenuePath === '/financialinsights' ?
            <div className='INCSUBRevenue_ctn'>
                <div className='INCSUBRevenue_ctn_search_cal_btn_div'>
                    <div className='INCSUBRevenue_ctn_search_cal'>
                        <INCSUBSearchbar width={500} height={38} backgroundColor='#fff' placeholder={'Search'} param={{ func: handleSearch }} />
                        <div className='INCSUBuser_transaction_history_date_picker'>
                            <DatePicker selected={startDate} onChange={(date) => {
                                setStartDate(date)
                                //    fetchTransactionDetails()
                            }} selectsStart endDate={endDate} maxDate={endDate} placeholderText='Start Date' showIcon icon={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_367_5814)">
                                    <path d="M12.6097 2.71875H3.37491C2.64631 2.71875 2.05566 3.3094 2.05566 4.038V13.2727C2.05566 14.0013 2.64631 14.592 3.37491 14.592H12.6097C13.3383 14.592 13.9289 14.0013 13.9289 13.2727V4.038C13.9289 3.3094 13.3383 2.71875 12.6097 2.71875Z" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.6299 1.40625V4.04475" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M5.35449 1.40625V4.04475" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2.05566 6.67969H13.9289" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_367_5814">
                                        <rect width="15.831" height="15.831" fill="white" transform="translate(0.0771484 0.0859375)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            } /> {"  -  "}
                            <DatePicker selected={endDate} onChange={(date) => {
                                setEndDate(date)
                                //    fetchTransactionDetails()
                            }} selectsEnd startDate={startDate} endDate={endDate} minDate={startDate} placeholderText='End Date' showIcon icon={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_367_5814)">
                                    <path d="M12.6097 2.71875H3.37491C2.64631 2.71875 2.05566 3.3094 2.05566 4.038V13.2727C2.05566 14.0013 2.64631 14.592 3.37491 14.592H12.6097C13.3383 14.592 13.9289 14.0013 13.9289 13.2727V4.038C13.9289 3.3094 13.3383 2.71875 12.6097 2.71875Z" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.6299 1.40625V4.04475" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M5.35449 1.40625V4.04475" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2.05566 6.67969H13.9289" stroke="black" stroke-width="1.31925" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_367_5814">
                                        <rect width="15.831" height="15.831" fill="white" transform="translate(0.0771484 0.0859375)" />
                                    </clipPath>
                                </defs>
                            </svg>
                            } />
                        </div>
                    </div>
                    <div className='INCSUBRevenue_button_container'>
                        <div><strong>Wallet Amount : {revenueData && revenueData.profitLossDto && revenueData.profitLossDto.totalWalletAmount ? revenueData.profitLossDto.totalWalletAmount : 0}</strong></div>
                        <INCSUBButton text='Payout' clickFun={handleRequestList} />
                        <div className='INCSUBRevenue_ctn_search_cal_btn' onClick={() => {
                            setIsAddtxn(true)
                            setSelectedTxn(null)
                        }}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 4.16406V15.8307" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.16699 10H15.8337" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Custom Transaction
                        </div>
                    </div>
                </div>
                <div className='INCSUBRevenue_content_container'>
                    <div className='INCSUBRevenue_cardholders_div'>
                        <INCSUBRevenueIncomeCard heading={'Income'} amount={revenueData?.profitLossDto?.totalIncome} svgImg={svgIncomeSvg} bg={'rgba(0, 182, 155, 0.2)'} func={handleType} isFocused={isFocused} />
                        <INCSUBRevenueIncomeCard heading={'Expense'} amount={revenueData?.profitLossDto?.totalExpense} svgImg={svgExpense} bg={'rgba(249, 60, 101, 0.2)'} func={handleType} isFocused={isFocused} />
                        <INCSUBRevenueIncomeCard heading={'All'} amount={revenueData?.profitLossDto?.totalProfit} svgImg={profitIcon} bg={'rgba(254, 197, 61, 0.2)'} func={handleType} isFocused={isFocused} />

                    </div>
                    <div className='INCSUBUser_userlist_section'>
                        {revenueData && revenueData.transactionDtoList.length > 0 ?
                            <>{!shimmer ? <div className='INCSUBUser_userlist_section_table_conatiner'>
                                <table className='INCSUBuser_table'>
                                    <thead className='INCSUBuser_table_head'>
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Date</th>
                                            <th>Payment Types</th>
                                              <th>Invoice ID</th>
                                            <th>Transaction ID </th>
                                            <th>Order ID </th>
                                            <th>Amount</th>
                                            <th>Remarks</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className='INCSUBuser_table_body'>
                                        {
                                            revenueData && revenueData.transactionDtoList.length > 0 && revenueData.transactionDtoList.map((revenue, index) =>
                                                <tr onClick={() => {
                                                    // handleRouteDetails();
                                                    // dispatch(setSelectedComplaint(complaint));
                                                }
                                                }>
                                                    <td>{index + 1}</td>
                                            
                                                    <td><div className='INCSUBprofile_name_container'>
                                                        <div className='INCSUBProfile_image_holder'>
                                                            <img src={revenue.userImage ? revenue.userImage : '/assets/icons/common/defaultImage.png'} alt='/' />
                                                        </div>
                                                        <div className='name_conatiner'>
                                                            <div className='name'>{revenue?.transactionByUserFullName}</div>
                                                            <div className='mobile_no'>{revenue?.transactionByUserNumber}</div>
                                                        </div>
                                                    </div></td>
                                                    <td>{formatDateTime(revenue.transactionDate)}</td>

                                                    <td>{revenue.paymentMode}</td>
                                                            <td style={{ color: "rgba(61, 66, 223, 1)" }}>{revenue.invoiceId}</td>
                                                    <td >{revenue.transactionId}</td>
                                                    <td style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }} onClick={() => revenue.transactionOrderId ? handleOrderHistoryPopup(revenue.transactionOrderId) : null}>{revenue.transactionOrderId}</td>
                                                    <td>₹{revenue.transactionAmount}</td>
                                                    <td>{revenue.transactionRemark ? revenue.transactionRemark : "-"}</td>
                                                    <td>{revenue.customTransaction ? <div className='INCSUBRevenue_listui_ctn_rowHeading_Amount' style={{ color: 'rgba(32, 34, 36, 1)', fontWeight: 500 }}>
                                                        <div className='INCSUB_UserActionDeleteIcon' onClick={() => {
                                                            setSelectedTxn(revenue)
                                                            setIsOpenPopup(true)
                                                            setIsAsk(true);
                                                        }
                                                        }>
                                                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M11.25 13.5H12.75H24.75" stroke="black" stroke-opacity="0.8" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M23.248 13.5V24C23.248 24.3978 23.09 24.7794 22.8087 25.0607C22.5274 25.342 22.1459 25.5 21.748 25.5H14.248C13.8502 25.5 13.4687 25.342 13.1874 25.0607C12.9061 24.7794 12.748 24.3978 12.748 24V13.5M14.998 13.5V12C14.998 11.6022 15.1561 11.2206 15.4374 10.9393C15.7187 10.658 16.1002 10.5 16.498 10.5H19.498C19.8959 10.5 20.2774 10.658 20.5587 10.9393C20.84 11.2206 20.998 11.6022 20.998 12V13.5" stroke="black" stroke-opacity="0.8" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M16.502 17.25V21.75" stroke="black" stroke-opacity="0.8" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M19.498 17.25V21.75" stroke="black" stroke-opacity="0.8" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </div>
                                                        <div className='INCSUB_UserActionEditeIcon' onClick={() => {
                                                            setSelectedTxn(revenue)
                                                            setIsAddtxn(true)
                                                        }
                                                        }  >
                                                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M18 24H24.75" stroke="black" stroke-opacity="0.8" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M21.375 11.6222C21.6734 11.3239 22.078 11.1562 22.5 11.1562C22.7089 11.1562 22.9158 11.1974 23.1088 11.2774C23.3019 11.3573 23.4773 11.4745 23.625 11.6222C23.7727 11.77 23.8899 11.9454 23.9699 12.1384C24.0498 12.3314 24.091 12.5383 24.091 12.7472C24.091 12.9562 24.0498 13.1631 23.9699 13.3561C23.8899 13.5491 23.7727 13.7245 23.625 13.8722L14.25 23.2472L11.25 23.9972L12 20.9972L21.375 11.6222Z" stroke="black" stroke-opacity="0.8" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </div>
                                                    </div> : "-"}</td>

                                                </tr>)
                                        }
                                    </tbody>
                                </table>
                            </div> : <div className='loader_container'>
                                <div className='revenue_loader' />
                            </div>}</> : <div className='INCSUBRevenue_empty'>No Data Available</div>}
                    </div>
                    <PaginatedItems />
                    {isAddtxn ? <INCSUBAddCustomTransaction onClick={setIsAddtxn} selectedTxn={selectedTxn} txnType={txnType} /> : null}
                    {isOrderHistory ? <INCSUBOrderDetails onClose={setIsOrderHistory} orderId={orderId} /> : null}
                    {isOpenPopUp ?
                        <div className='INCSUBCategory_permission_popup'>{
                            isAsk ?
                                <div className='INCSUBCategory_ask_container' >
                                    <div className='INCSUBCategory_ask' style={{ display: txnDeleteLoader ? 'none' : null }}>
                                        <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="49.0815" cy="46.0102" r="32.0883" fill="#FF6565" />
                                            <circle cx="13.778" cy="7.87368" r="7.87368" fill="#FF6565" fill-opacity="0.2" />
                                            <circle cx="93.1719" cy="15.749" r="5.90526" fill="#FF6565" fill-opacity="0.2" />
                                            <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#FF6565" fill-opacity="0.2" />
                                            <circle cx="34.777" cy="91.2028" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                            <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                            <circle cx="89.235" cy="58.3903" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                            <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                            <path d="M47.5491 51.7008L46 32H52.1168L50.5677 51.7008H47.5491ZM46.278 60.0022V54.4812H51.8388V60.0022H46.278Z" fill="white" />
                                        </svg>




                                        <div className='INCSUBCategory_permission_header'>
                                            Are you sure to delete this transaction?
                                        </div>
                                        <div className='INCSUBCategory_permission_btn_container'>
                                            <div className="INCSUBCategory_image_upload_btn">
                                                <div className='INCSUBCategory_upload_btn' onClick={() => handleDelete(selectedTxn)}>Delete</div>
                                                <div className='upload_cancel_btn' onClick={() => setIsOpenPopup(false)}>Cancel</div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        txnDeleteLoader ? <div className='categoryloader' /> : null
                                    }
                                </div> : <div className='INCSUBCategory_ask_container'>
                                    <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="49.0805" cy="46.0102" r="32.0883" fill="#FF6565" />
                                        <path d="M59 37L41 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M41 37L59 55" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                                        <circle cx="13.778" cy="7.87368" r="7.87368" fill="#FF6565" fill-opacity="0.2" />
                                        <circle cx="93.1709" cy="15.749" r="5.90526" fill="#FF6565" fill-opacity="0.2" />
                                        <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#FF6565" fill-opacity="0.2" />
                                        <circle cx="34.777" cy="91.2028" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                        <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                        <circle cx="89.234" cy="58.3903" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                        <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#FF6565" fill-opacity="0.2" />
                                    </svg>
                                    <div className='INCSUBCategory_permission_header'>
                                        Can’t delete
                                    </div>
                                    <div className='INCSUBCategory_permission_text'></div>
                                    <div className='INCSUBCategory_permission_btn_container'>
                                        <div className="INCSUBCategory_image_upload_btn">
                                            <div className='INCSUBCategory_upload_btn' onClick={() => setIsOpenPopup(false)}>Ok, Got it</div>
                                            {/* <div className='upload_cancel_btn'>Cancel</div> */}
                                        </div>
                                    </div>
                                </div>
                        }


                        </div> : null
                    }
                </div>
            </div> :
            <INCSUBRequestList />
        }
        </>
    )
}

export default INCSUBRevenue;
